<template>
  <div>
    <button
      v-if="!isFavorited"
      title="Favorite"
      v-tippy="{ placement: 'top' }"
      @click="favorite"
    >
      <font-awesome-icon :icon="faStar" />
    </button>
    <button
      v-else
      title="Unfavorite"
      v-tippy="{ placement: 'top' }"
      @click="unfavorite"
    >
      <font-awesome-icon :icon="faStarFull" />
    </button>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faStar } from "@fortawesome/pro-light-svg-icons/faStar";
import { faStar as faStarFull } from "@fortawesome/pro-solid-svg-icons/faStar";
import axios from "axios";
import { createNamespacedHelpers } from "vuex";
import { errorNotification } from "../../notifications";

const { mapState, mapActions } = createNamespacedHelpers("activitySummary");

export default {
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      faStar,
      faStarFull,
    };
  },
  computed: {
    ...mapState(["activity"]),
    favoriteRequestUrl() {
      return `${this.$_activitySummary_config.jiminnyHost()}/api/v1/activity/${
        this.activity.id
      }/favorite`;
    },
    isFavorited() {
      return this.activity.favorited;
    },
  },
  methods: {
    ...mapActions(["favoriteActivity", "unfavoriteActivity"]),
    favorite() {
      axios
        .put(this.favoriteRequestUrl)
        .then(this.favoriteActivity)
        .catch(this.handleErrors);
    },
    unfavorite() {
      axios
        .delete(this.favoriteRequestUrl)
        .then(this.unfavoriteActivity)
        .catch(this.handleErrors);
    },
    handleErrors(errors) {
      let message = "Something went wrong. Please try again later.";

      if (errors.response.status === 403) {
        message = "You are not authorized to perform this action.";
      } else if (errors.response.status === 409) {
        message = "Favorite already exists.";
      }

      errorNotification({ message }).show();
    },
  },
};
</script>



// WEBPACK FOOTER //
// favourite.vue?f81c2256